import { render, staticRenderFns } from "./DeleteTenant.vue?vue&type=template&id=4cbfaf4c"
import script from "./DeleteTenant.vue?vue&type=script&lang=js"
export * from "./DeleteTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports